import Marquee from "react-fast-marquee";
import { useLang } from "../../i18n";

const MarqueeBand = () => {
  const { t } = useLang();
  return (
    <div className="border-y border-[#232733] bg-[#0A0B0E] py-5 overflow-hidden" data-testid="marquee-band">
      <Marquee speed={35} gradient={false}>
        {t.marquee.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-2xl lg:text-3xl font-medium uppercase tracking-tight text-[#232733] [-webkit-text-stroke:1px_#3a4152] px-6">
              {item}
            </span>
            <span className="text-[#FF4D00] text-xl">•</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};

export default MarqueeBand;
